export const lineActionTypes = {
	LIST_LINE: 'LIST_LINE',
	FILTER_LINE_NAME: 'FILTER_LINE_NAME',
};
